module.exports = __webpack_public_path__ + "img/youtube.b26ca975.svg";